import { render } from "./Netflixorigional.vue?vue&type=template&id=6f4f139c&scoped=true"
import script from "./Netflixorigional.vue?vue&type=script&lang=js"
export * from "./Netflixorigional.vue?vue&type=script&lang=js"

import "./Netflixorigional.vue?vue&type=style&index=0&id=6f4f139c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6f4f139c"

export default script